import { render, staticRenderFns } from "./TarefasPage.vue?vue&type=template&id=3f73f134"
import script from "./TarefasPage.vue?vue&type=script&lang=js"
export * from "./TarefasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports